(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

module.exports = Vue.component('repeater',{
    props:['label','value','button','rendercomponent'],
    data: function(){
        return {
            
        }
    },
    methods:{
        handleChange(){
            this.$emit('change',this.value);
        },
        newItem(){
            const newAccount = {
                handle: '',
                token: '',
                id: Math.random()
                
            }
            this.value.push(newAccount);
            this.handleChange();
        },
        removeItem(e,item){
            e.preventDefault();
            const items = this.value.filter(arrayItem => arrayItem.id !== item.id)
            this.value = items;
            this.handleChange();
        }

    },
    template:
     `<div class="vue-repeater">
        <div class="option">
            <p><b><label>{{label}}</label></b></p>
            
            <div class="items" v-for="item in value" key="item.id">
                <div class="admin-box">
                    <component :is="rendercomponent" v-bind:item="item"></component>
                    <a href="#" @click="removeItem(event,item)">delete</a>
                </div>
            </div>
            <div class="repeated-controls">
                <button @click="newItem">{{button}}</button>
            </div>
        </div>
     </div>`
 });
 
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/vue/components/repeater.js","/vue/components")